import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * LightBulb icon
 *
 * @category Business
 */
const LightBulb = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M23.443 16.582C28.51 8.371 18.753-.806 10.84 4.64c-4.17 2.6-4.83 9.272-1.807 12.71.886 1.121 2.09 2.007 2.882 3.224 1.04 1.606 1.063 2.834 1.051 4.866.024 1.535-.319 3.673 1.831 3.532 1.098-.024 2.457.177 3.484-.237.473-.248.614-.791.662-1.57.118-2.056-.296-4.253.78-6.13 1.062-1.879 2.692-2.788 3.637-4.312l.095-.142zM17.43 27.649c-.33.177-1.217.094-1.949.106-.661 0-1.075-.059-1.193-.413-.177-.674-.07-.957-.106-1.583 0-.543 0-1.04.283-1.288.72-.46 2.02-.295 2.835-.189.449.13.449.662.449 1.465-.024.803.07 1.583-.201 1.82l-.106.07zm.012-4.937c-1.666.65-.378-6.898-1.158-8.268-2.386-1.796 1.04 14.043-3.425 5.693-1.406-2.103-3.614-3.614-4.288-6.178-1.51-4.819 2.517-10.346 7.643-10.016 5.375.036 9.083 6.331 6.71 11.103-1.064 2.268-3.26 3.744-4.395 5.977-.39.685-.685 1.31-.992 1.606l-.082.07z"
        />
      </svg>
    );
  }
);

LightBulb.displayName = 'LightBulb';

export { LightBulb };
